// extracted by mini-css-extract-plugin
export default {"globalNav":"globalNav___jh1Tc","globalNavOpen":"globalNavOpen___kSyN_","globalNavFixed":"globalNavFixed___PPX6p"};